import shop from "../api/shop";
import moment from "moment";
import {
  LOADING_ORDERS,
  SEARCH_LOADING,
  ORDERS_STORE,
  ORDER_STORE,
  SEARCH_TERM,
  FILTERED_ORDERS,
  ORDERS_SORT_BY,
  ORDERS_SORT_ORDER,
  ORDERS_RANGE_CHANGE,
  FILTER_ORDERS_BY_RANGE,
  RESET_RANGE_FILTER,
  SORT_ORDERS,
  DOWNLOADING_ORDER_PDF
} from "./actionTypes";
import { orderState } from "./stateModel";
import { setOpenedActions } from "./customer";

// ------------------------------------
// Actions
// ------------------------------------

export const orderLoading = status => ({
  type: LOADING_ORDERS,
  status
});

const loadingUnsafe = status => ({
  type: LOADING_ORDERS,
  status
});

const searchLoadingUnsafe = loading => ({
  type: SEARCH_LOADING,
  loading
});

const downloadingPDFUnsafe = id => ({
  type: DOWNLOADING_ORDER_PDF,
  id
});

export const downloadingPDF = id => dispatch => {
  dispatch(downloadingPDFUnsafe(id));
};

const receiveOrdersData = orders => ({
  type: ORDERS_STORE,
  orders
});

export const storeOrdersData = orders => (dispatch, getState) => {
  dispatch(receiveOrdersData(orders));
  // if(getState().order.term.length > 0){
  //   let term = getState().order.term;
  //   let ordersList = getState().order.list;
  //   let f = ordersList.filter(l => l.id.toString().includes(term) || l.amount.toString().includes(term) || l.price.toString().includes(term))
  //   dispatch(storeFilteredList(f))
  // }else{
  //   dispatch(storeFilteredList(orders))
  // }
};

const receiveOrderData = order => ({
  type: ORDER_STORE,
  order
});

export const storeOrderData = order => dispatch => {
  dispatch(receiveOrderData(order));
};

const changeSortByUnsafe = sortBy => ({
  type: ORDERS_SORT_BY,
  sortBy
});

export const changeOrdersSortBy = sortBy => dispatch => {
  dispatch(changeSortByUnsafe(sortBy));
};

const changeSortOrderUnsafe = sortOrder => ({
  type: ORDERS_SORT_ORDER,
  sortOrder
});

export const changeOrdersSortOrder = sortOrder => dispatch => {
  dispatch(changeSortOrderUnsafe(sortOrder));
};

export const filterList = term => (dispatch, getState) => {
  dispatch(storeTerm(term));
  let ordersList = getState().order.list;
  let f = ordersList.filter(
    l =>
      l.id.toString().includes(term) ||
      l.amount.toString().includes(term) ||
      l.price.toString().includes(term)
  );
  dispatch(storeFilteredList(f));
};

const changeFilterUnsafe = (term, col) => ({
  type: FILTERED_ORDERS,
  term,
  col
});

export const changeOrdersList = (term, type) => dispatch => {
  dispatch(loadingUnsafe(true));
  dispatch(changeFilterUnsafe(term, type));
  dispatch(loadingUnsafe(false));
};

const sortOrdersUnsafe = (sortBy, sortOrder) => ({
  type: SORT_ORDERS,
  sortBy,
  sortOrder
});

export const sortOrdersList = (sortBy, sortOrder) => (dispatch, getState) => {
  dispatch(loadingUnsafe(true));
  dispatch(sortOrdersUnsafe(sortBy, sortOrder));
  // shop.getSortedOrders(sortBy, sortOrder, getState().order.list, (sortedOrders) => {
  //   // dispatch(receiveOrdersData(sortedOrders))
  // })
  dispatch(loadingUnsafe(false));
};

const changeRangeUnsafe = (value, rangeType) => ({
  type: ORDERS_RANGE_CHANGE,
  value,
  rangeType
});

const filterOrdersByRangeUnsafe = (from, to) => ({
  type: FILTER_ORDERS_BY_RANGE,
  from,
  to
});
const resetRangeFilter = () => ({
  type: RESET_RANGE_FILTER
});

export const changeRange = (value, type) => (dispatch, getState) => {
  dispatch(changeRangeUnsafe(value, type));
  if (getState().order.rangeFrom && getState().order.rangeTo) {
    dispatch(loadingUnsafe(true));
    dispatch(
      filterOrdersByRangeUnsafe(
        moment(getState().order.rangeFrom).unix(),
        moment(getState().order.rangeTo).unix()
      )
    );
    dispatch(loadingUnsafe(false));
  }
  if (!getState().order.rangeFrom && !getState().order.rangeTo) {
    dispatch(loadingUnsafe(true));
    dispatch(resetRangeFilter());
    dispatch(loadingUnsafe(false));
  }
};

export const getOrdersList = state => (state ? state : []);
export const getFilteredOrdersList = state => (state ? state : {});
export const getOrderDetail = state => (state ? state : {});
export const getCompanyDetail = state => (state ? state : null);
export const getTerm = state => (state ? state : "");
export const getFromDate = state => (state ? state : null);
export const getToDate = state => (state ? state : null);

// ------------------------------------
// Reducer
// ------------------------------------
// const initialState = [];
export default function orderReducer(state = orderState, action) {
  switch (action.type) {
    case ORDERS_STORE:
      return {
        ...state,
        list: action.orders,
        fullList: action.orders
      };
    case ORDER_STORE:
      return {
        ...state,
        detail: action.order
      };
    case SEARCH_TERM:
      return {
        ...state,
        term: action.term
      };
    // case FILTERED_ORDERS :
    //   let fl = Object.assign([], state.filter);
    //   let fi = fl.findIndex(f => f.type === action.col);
    //   if(fi !== -1){
    //     fl[fi].value = action.term
    //   }else{
    //     fl.push({type:action.col,value:action.term});
    //   }
    //   return{
    //     ...state,
    //     filter: fl
    //   }

    case FILTERED_ORDERS:
      let fl = Object.assign([], state.filter);
      let fi = fl.findIndex(f => f.type === action.col);
      if (fi !== -1) {
        if (parseInt(action.term) === -1 || action.term === "") {
          fl.splice(fi, 1);
        } else {
          fl[fi].value = action.term;
        }
      } else {
        fl.push({ type: action.col, value: action.term });
      }
      const dataSource1 =
        state.rangeFrom || state.rangeTo
          ? state.fullList.filter(
              o =>
                moment(state.rangeFrom).unix() < o.date &&
                o.date < moment(state.rangeTo).unix()
            )
          : state.fullList;
      const filteredOrders = dataSource1.filter(product =>
        fl.every(
          filter =>
            product[filter.type]
              ? product[filter.type]
                  .toString()
                  .toLowerCase()
                  .includes(filter.value.toString().toLowerCase())
              : false
        )
      );
      return {
        ...state,
        filter: fl,
        list: filteredOrders
      };
    case RESET_RANGE_FILTER:
      return {
        ...state,
        rangeFrom: null,
        rangeTo: null,
        list: state.fullList
      };
    case FILTER_ORDERS_BY_RANGE:
      return {
        ...state,
        list: state.fullList.filter(
          o => action.from < o.date && o.date < action.to
        )
      };
    case ORDERS_SORT_BY:
      return {
        ...state,
        sortBy: action.sortBy
      };
    case ORDERS_SORT_ORDER:
      return {
        ...state,
        sortOrder: action.sortOrder
      };
    case ORDERS_RANGE_CHANGE:
      return {
        ...state,
        [action.rangeType]: action.value
      };
    case SORT_ORDERS:
      const { sortBy, sortOrder } = action;
      const dataSorted = [...state.list].sort((a, b) =>
        a[sortBy]
          .toString()
          .toLowerCase()
          .localeCompare(b[sortBy].toString().toLowerCase())
      );
      const dataSortedAndOrdered =
        sortOrder === "asc" ? dataSorted : dataSorted.reverse();
      return {
        ...state,
        sortBy: sortBy,
        sortOrder: sortOrder,
        list: dataSortedAndOrdered,
        fullList: dataSorted
      };
    case DOWNLOADING_ORDER_PDF:
      const data = Object.assign([], state.list);
      const foundRow = data.find(r => r.id === action.id);
      if (foundRow) foundRow.isPDFLoading = !foundRow.isPDFLoading;
      return { ...state, list: data };
    case LOADING_ORDERS:
      return { ...state, orderLoading: action.status };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/order.js